// @flow

export const setFlash = (message: string, msgType: any) => {
  return { type: 'SET_FLASH', message, msgType };
}

export const clearFlash = () => {
  return { type: 'CLEAR_FLASH' }
}



// WEBPACK FOOTER //
// ./src/actions/common/flash.js